import { api } from './api';

export const widgetClienteService = {
  getWidgetClienteRvcIpaKpi,
  getWidgetClienteRvcIpa,
  postWidgetClienteRvcIpa,
  getWidgetClienteCmpcDiasPerdidos,
  postWidgetClienteCmpcDiasPerdidos,
  getWidgetClienteCmpcDiasPerdidosTabla,
  getWidgetClienteEsach_datos_estandar_dotacion,
  getWidgetClienteEsach_datos_estandar_recalificacion,
  getWidgetClienteEsach_datos_estandar_siniestros,
  getWidgetClienteEsach_datos_estandar_prestaciones_economicas,
  getWidgetClienteEsach_reporte_accidentabilidad,
  getWidgetClienteEsach_reporte_accidentabilidad_getFiltros
};

function getWidgetClienteEsach_reporte_accidentabilidad_getFiltros(data) {
  return api.post(
    api.tx.getWidgetClienteEsach_reporte_accidentabilidad_getFiltros, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteEsach_reporte_accidentabilidad(data) {
  return api.post(
    api.tx.getWidgetClienteEsach_reporte_accidentabilidad, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteEsach_datos_estandar_dotacion(data) {
  return api.post(
    api.tx.getWidgetClienteEsach_datos_estandar_dotacion, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteEsach_datos_estandar_recalificacion(data) {
  return api.post(
    api.tx.getWidgetClienteEsach_datos_estandar_recalificacion, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteEsach_datos_estandar_siniestros(data) {
  return api.post(
    api.tx.getWidgetClienteEsach_datos_estandar_siniestros, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteEsach_datos_estandar_prestaciones_economicas(data) {
  return api.post(
    api.tx.getWidgetClienteEsach_datos_estandar_prestaciones_economicas, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteCmpcDiasPerdidos(data) {
  return api.post(
    api.tx.getWidgetClienteCmpcDiasPerdidos, 
    data
  ).then(data => {
    return data;
  });
}

function postWidgetClienteCmpcDiasPerdidos(data) {
  return api.post(
    api.tx.postWidgetClienteCmpcDiasPerdidos, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteCmpcDiasPerdidosTabla(data) {
  return api.post(
    api.tx.getWidgetClienteCmpcDiasPerdidosTabla, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteRvcIpaKpi(data) {
  return api.post(
    api.tx.getWidgetClienteRvcIpaKpi, 
    data
  ).then(data => {
    return data;
  });
}

function getWidgetClienteRvcIpa(data) {
  return api.post(
    api.tx.getWidgetClienteRvcIpa, 
    data
  ).then(data => {
    return data;
  });
}

function postWidgetClienteRvcIpa(data) {
  return api.post(
    api.tx.postWidgetClienteRvcIpa, 
    data
  ).then(data => {
    return data;
  });
}